import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { faAngleLeft, faAngleRight } from "../../utilities/fontawesomeIcons";
import { useAppContext } from "../../AppProvider";

interface GenericCarouselProps<T> {
  data: T[]; // Deve essere un array per poter scorrere
  id: string;
  renderItem: (item: T, index: number) => React.ReactNode;
  showIndicators?: boolean;
  showControls?: boolean;
  numberIndicators?: boolean;
}

export const GenericCarousel = <T,>({
  data,
  id,
  renderItem,
  showIndicators = true,
  showControls = true,
}: GenericCarouselProps<T>) => {
  const { breakpoint } = useAppContext();
  const isSmall = ["xs"].includes(breakpoint);
  const isLarge = ["md"].includes(breakpoint);

  // Se non ci sono dati o l'array è vuoto, non renderizzare nulla
  if (!data || data.length === 0) return null;

  return (
    <div
      id={id}
      className="carousel slide d-flex align-items-center justify-content-evenly w-100"
      data-bs-ride="false"
    >
      {/* Freccia Precedente Fuori */}
      <div>
        {showControls && data.length > 1 && (
          <button
            className="btn border-0 px-1"
            type="button"
            data-bs-target={`#${id}`}
            data-bs-slide="prev"
          >
            <FontAwesomeIcon icon={faAngleLeft} color="black" size="2x" />
            <span className="visually-hidden">Precedente</span>
          </button>
        )}
      </div>
      {/* Contenitore Centrale con Bordo */}
      <div className="position-relative">
        <div
          className="carousel-inner rounded-1"
          style={{
            border: "1px solid #ddd",
            width: isSmall ? "230px" : isLarge ? "300px" : "340px",
            minHeight: "200px",
            overflow: "hidden",
          }}
        >
          {data.map((item, index) => (
            <div
              key={`slide-${index}`}
              className={`carousel-item ${index === 0 ? "active" : ""}`}
            >
              <div className="p-2 text-center">{renderItem(item, index)}</div>
            </div>
          ))}
        </div>
        {/* Indicatori posizionati sotto il bordo se necessario */}
        <div>
          {showIndicators && data.length > 1 && (
            <div
              className="carousel-indicators"
              style={{ marginBottom: "-35px" }}
            >
              {data.map((_, index) => (
                <button
                  key={`indicator-${index}`}
                  type="button"
                  data-bs-target={`#${id}`}
                  data-bs-slide-to={index}
                  className={`bg-black ${index === 0 ? "active" : ""}`}
                  aria-current={index === 0 ? "true" : "false"}
                  style={{
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    cursor: "pointer",
                    margin: "0 5px",
                  }}
                ></button>
              ))}
            </div>
          )}
        </div>
      </div>
      <div>
        {showControls && data.length > 1 && (
          <button
            className="btn border-0 px-1"
            type="button"
            data-bs-target={`#${id}`}
            data-bs-slide="next"
          >
            <FontAwesomeIcon icon={faAngleRight} color="black" size="2x" />
          </button>
        )}
      </div>
    </div>
  );
};
